@if (ife_format) {
  <!-- cl-spacing-none: its columns already carry the field spacing; cl-spacing-small on top made the
       gap above Aspect Ratio 43 px instead of the usual ~23 (measured on :4200). -->
  <div class="row cl-spacing-none" [formGroup]="form">
    <div class="col-12" [class.col-md-6]="!form?.controls['metadata_reference']" [class.col-md-4]="form?.controls['metadata_reference']">
      <label for="aspect_ratio" class="form-label">Aspect Ratio</label>
      <select id="aspect_ratio" class="form-select" formControlName="aspect_ratio">
        <option value="passthrough">Pass-through
        </option>
        <optgroup label="Stretch to fill the frame">
          @for (ratio of aspectRatios; track ratio) {
            <option [value]="ratio">Force {{ ratio }}
            </option>
          }
        </optgroup>
        <optgroup label="Fit inside the frame, with black bars">
          @for (ratio of aspectRatios; track ratio) {
            <option [value]="ratio + '_framed'">Fit into {{ ratio }}
            </option>
          }
        </optgroup>
      </select>
      @if (!form?.controls['aspect_ratio'].errors) {
        <p class="valid-feedback">Pass-through delivers the source's own shape. Force stretches the picture to the
          ratio; Fit keeps its geometry and pads with black. Set only if the encode fails in pass-through.</p>
      }
    </div>
    <!-- The airline-registered default watermark. A template without it (e.g. castlabs-vod v2, whose
         customer-defined watermark is a setting in its own card) shows no switch at all -- unless
         the source requires a watermark, which then has to explain why this format cannot. -->
    @if (showWatermark) {
      <div class="col-12" [class.col-md-6]="!form?.controls['metadata_reference']" [class.col-md-4]="form?.controls['metadata_reference']">
        <label for="watermark" class="form-label">Watermark</label>
        <select id="watermark" class="form-select" formControlName="watermark" (change)="onWatermarkChange()">
          <option [ngValue]="true">Insert forensic watermark
          </option>
          @if (!watermarkRequired) {
            <option [ngValue]="false">No watermark
            </option>
          }
        </select>
        @if (watermarkSupported === null) {
          <!-- Unknown is not "unsupported": the switch waits for template_capabilities. -->
          @if (capabilitiesFailed) {
            <!-- An alert, not .invalid-feedback: nothing is wrong with the field itself, and castlabs-ui
                 only shows .invalid-feedback after an input marked .invalid. -->
            <div class="alert cl-alert-danger cl-spacing-tiny" role="alert" data-watermark-unknown>Could not load this
              format's capabilities, so whether it can watermark is unknown. Reselect the format to retry.</div>
          } @else {
            <p class="valid-feedback" data-watermark-unknown>Loading this format's capabilities&hellip;</p>
          }
        } @else if (watermarkImpossible) {
          <!-- A warning, not an error style: the operator cannot fix it in this field (styleguide: Warning). -->
          <div class="alert cl-alert-warning cl-spacing-tiny" role="alert" data-watermark-impossible>This source is
            pre-release content and must be watermarked, but this target format cannot insert a forensic watermark.</div>
        } @else if (watermarkRequired) {
          <p class="valid-feedback">This source is pre-release content: a forensic watermark is required.</p>
        } @else if (!form?.controls['watermark'].errors) {
          <p class="valid-feedback">Insert or omit forensic watermark.</p>
        }
      </div>
    }
    @if (form?.controls['metadata_reference']) {
      <div class="col-12 col-md-4">
        <label for="metadata_reference" class="form-label">Metadata Reference<span class="required">*</span></label>
        <input id="metadata_reference" type="text" formControlName="metadata_reference"
               [class.invalid]="showInvalid('metadata_reference')">
        @if (form?.controls['metadata_reference'].errors?.required) {
          <p class="invalid-feedback">This field is required.</p>
        }
        <p class="valid-feedback">A format specific reference to the metadata.</p>
      </div>
    }
  </div>
}
